import {Space} from "antd";
import {SubSettingsFormFieldsProps} from "./types";
import {SubSettingsHideFromProfileFormField} from "./hide-from-profile";
import {SubSettingsPurchaseLimitFormField} from "./purchase-limit";
import {SubSettingsRequestCustomerPhoneNumberFormField} from "./request-customer-phone-number";
import {SubSettingsUrlRedirectFormField} from "./url-redirect";

export function SubSettingsFormFields({
  hideFromProfileLabel,
  requestCustomerPhoneNumberLabel,
  purchaseLimitLabel,
  urlRedirectLabel,
  showUrlRedirect = true,
}: SubSettingsFormFieldsProps) {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {purchaseLimitLabel && (
          <SubSettingsPurchaseLimitFormField label={purchaseLimitLabel} />
        )}
        <SubSettingsHideFromProfileFormField label={hideFromProfileLabel} />
        <SubSettingsRequestCustomerPhoneNumberFormField
          label={requestCustomerPhoneNumberLabel}
        />
        {showUrlRedirect && <SubSettingsUrlRedirectFormField label={urlRedirectLabel} />}
      </Space>
    </div>
  );
}
